export const getBrightness = async () => 0;
